import {
  GET_LIST_TRAGOP,
  GET_LIST_TRAGOP_SUCCESS,
  GET_LIST_TRAGOP_FAILURE,
} from 'actions/TraGop/actionTypes';

const initialState = {
  getListTraGopLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
    sNguonKhachHang:""
  },
  totalRow: 0,
  dataSearch: {},
};

const getListTraGop = (state, action) => ({
  ...state,
  getListTraGopLoading: true,
  dataSearch: action.dataSearch,
});

const getListTraGopSuccess = (state, action) => {
  return {
    ...state,
    getListTraGopLoading: false,
    objList: action.payload,
  };
};

const getListTraGopFailed = (state, action) => ({
  ...state,
  getListTraGopLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_TRAGOP:
      return getListTraGop(state, action);
    case GET_LIST_TRAGOP_SUCCESS:
      return getListTraGopSuccess(state, action);
    case GET_LIST_TRAGOP_FAILURE:
      return getListTraGopFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
